<navaar-header [title]="'کتابخانه'" [color]="'#000000'" [show-back-icon]="false">
  <span slot=custom-icon class="icon-sort-button" *ngIf="isLogin">
    <navaar-sort-icon (click)="showSortList()"></navaar-sort-icon>
    <navaar-search-icon style="display: inline-block; width: 18px" [routerLink]="['search-library']"></navaar-search-icon>
  </span>
</navaar-header>
<navaar-tabs [selected-index-tab]="tabNameContextMenu === 'library' ? 0 : tabNameContextMenu === 'bookmark' ? 1 : null ">
  <navaar-tab (onClick)="onTabClicked($any($event))" [Tab-Name]="'library'" [Tab-Title]="'کتابخانه من'">
    <ng-container
      *ngTemplateOutlet="this.boughtsItem?.length > 0 ? items : empty_bought_item; context: {$implicit:this.boughtsItem, type: 'library'}">
    </ng-container>
  </navaar-tab>
  <navaar-tab (onClick)="onTabClicked($any($event))" [Tab-Name]="'bookmark'" [Tab-Title]="'نشان شده'">
    <ng-container
      *ngTemplateOutlet="this.bookmarkItem?.length > 0 ? items : empty_bookmark_item; context: {$implicit:this.bookmarkItem, type: 'bookmark'}">
    </ng-container>
  </navaar-tab>
</navaar-tabs>

<ng-template #icon_bought_item>
  <svg xmlns="http://www.w3.org/2000/svg" width="52.511" height="70" viewBox="0 0 52.511 70">
    <path id="Path_3060" data-name="Path 3060"
      d="M167.594,299.863a38.867,38.867,0,0,1-3.987-1.091,14.4,14.4,0,0,1-9.124-13.253c-.033-11.708-.014-23.416-.009-35.124a2.9,2.9,0,0,1,3.07-3.027c1.864-.009,3.728,0,5.676,0v-.773c0-2.619-.006-5.239,0-7.858a8.746,8.746,0,0,1,8.886-8.866q8.61-.014,17.22,0a8.74,8.74,0,0,1,8.888,8.864c.009,2.845,0,5.69,0,8.633h1.027c1.549,0,3.1-.007,4.647,0a2.91,2.91,0,0,1,3.073,3.1c0,11.639.026,23.279-.008,34.918a14.539,14.539,0,0,1-12.736,14.358,2.1,2.1,0,0,0-.377.123Zm-7.28-46.617v.625q0,15.65,0,31.3a8.532,8.532,0,0,0,.1,1.5,8.677,8.677,0,0,0,8.717,7.343c7.7.022,15.4.008,23.1,0a8.694,8.694,0,0,0,8.879-8.921q.019-15.582,0-31.164c0-.22-.023-.44-.036-.684Zm32.058-5.909c0-2.875.007-5.677,0-8.478a2.883,2.883,0,0,0-3.144-3.144q-8.509-.01-17.018,0a2.88,2.88,0,0,0-3.141,3.145c-.009,2.62,0,5.24,0,7.86,0,.2.022.394.036.617Z"
      transform="translate(-154.463 -229.863)" fill="#fff" />
  </svg>
</ng-template>

<ng-template #icon_bookmark>
  <svg xmlns="http://www.w3.org/2000/svg" width="48.413" height="70" viewBox="0 0 48.413 70">
    <path id="_030-bookmark" data-name="030-bookmark"
      d="M129.033,69.071l-19.112-21.1L90.81,69.071a2.828,2.828,0,0,1-4.923-1.9l.343-64.344A2.828,2.828,0,0,1,89.057,0h42.415A2.828,2.828,0,0,1,134.3,2.828l-.343,64.344a2.828,2.828,0,0,1-4.923,1.9ZM109.922,40.933a2.828,2.828,0,0,1,2.1.929L128.3,59.839l.343-54.183H91.884l-.343,54.183,16.284-17.977A5.173,5.173,0,0,1,109.922,40.933Z"
      transform="translate(-85.886)" fill="#fff" />
  </svg>
</ng-template>

<ng-template #empty_bought_item>
  <div class="container-empty" *ngIf="!isLoading">
    <div>
      <ng-container *ngTemplateOutlet="icon_bought_item"></ng-container>
      <ng-template [ngIf]="isLogin" [ngIfElse]="txt_logoff_user">
        <p>همه‌ی محتواهای خریداری شده شما اینجا نمایش داده می‌شود. محتواهای خریداری شده، همیشه در کتابخانه شما موجود
          خواهند بود.</p>
      </ng-template>
      <ng-container *ngTemplateOutlet="btn_goo_shop"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #empty_bookmark_item>
  <div class="container-empty" *ngIf="!isLoading">
    <div>
      <ng-container *ngTemplateOutlet="icon_bookmark"></ng-container>
      <ng-template [ngIf]="isLogin" [ngIfElse]="txt_logoff_user">
        <p>می‌توانید محتواهای مورد علاقه خود را نشان‌دار کنید، تا در زمان مناسب به آنها دسترسی سریع‌تری داشته باشید.</p>
      </ng-template>
      <ng-container *ngTemplateOutlet="btn_goo_shop"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #btn_goo_shop>
  <navaar-button (onClick)="isLogin ? goToShopPage() : goToLoginPage()" [type-button]="'button'" [color-name]="'blue'"
    [class-name]="'navaar-buttn-border-radius'">
    <span class="btn-style" [textContent]="isLogin ? 'مراجعه به فروشگاه': 'ورود یا ثبت نام'"></span>
  </navaar-button>
</ng-template>

<ng-template #txt_logoff_user>
  <p>هنوز وارد حساب کاربری خود نشده‌اید.</p>
</ng-template>

<ng-template #items let-items let-type="type">
  <div class="container-items">
    <ng-template ngFor [ngForOf]="items" let-item let-i="index">
      <ng-container
        *ngTemplateOutlet="carousel; context: { title: item.genreDisplayTitle, item: item.items, $implicit: item.genreIdentifier, type: type}">
      </ng-container>
    </ng-template>
  </div>
</ng-template>

<ng-template #carousel let-title="title" let-item="item" let-genreId let-type="type">
  <navaar-carousel [show-context-menu-icon]="true" [is-direct-play]="true" [is-route-to-pdp-isOwner-false]="tabNameContextMenu === 'bookmark'" (onClick-show-context-menu-icon)="showContextMenu($event, type)"
    (onClick-show-all)="onShowAll(+genreId, title, type)" [disable-route-show-all]="true" [show-rate]="false"
    [style-show-all]="'yellow'" [items]="{items: item}" [title]="title" [typeOfCarousel]="carouselType.Simple_H"
    [type-url]="'recommend'" [is-check-status-subscription]="true">
  </navaar-carousel>
</ng-template>

<navaar-context-menu-library
  (onRefresh)="onRefreshData()"
  [tab]="tabNameContextMenu"
  (OnClose)="onCloseContextMenu()"
  [isShow]="isShowContextMenu"
  [identifier]="identifierContextMenu"
  [isOwner]="isOwner"
  [audiobookTitle]="audiobookTitleContextMenu"
  [subscription-status]="subscriptionContextMenu"
  [audiobookId]="audiobookIdContextMenu"></navaar-context-menu-library>

<navaar-sort-list
  [container]="container"
  (select-sort)="selected($event)"
  [(visible)]="visible"></navaar-sort-list>
